import React from 'react';
import { clsx } from 'clsx';
import { useTheme } from '../../context/ThemeContext';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
}

export const Card: React.FC<CardProps> = ({
  children,
  className,
  padding = 'md',
  hover = false,
}) => {
  const { theme } = useTheme();

  const paddings = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const themeClasses = {
    light: 'bg-white border-gray-200 text-gray-900',
    dark: 'bg-gray-800 border-gray-700 text-white',
    gradient: 'bg-white/10 backdrop-blur-md border border-white/20 text-white shadow-xl', // Glass effect
  };

  return (
    <div
      className={clsx(
        'rounded-xl border shadow-sm transition-colors duration-300',
        themeClasses[theme],
        hover && 'transition-shadow duration-200 hover:shadow-md',
        paddings[padding],
        className
      )}
    >
      {children}
    </div>
  );
};





